"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcClient = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
class JsonRpcClient {
    constructor(url) {
        this.url = url;
    }
    post(method, params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const id = Math.random().toString(16).substring(7);
            const body = {
                jsonrpc: "2.0",
                id,
                method,
                params,
            };
            const httpResponse = yield cross_fetch_1.default(this.url, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            // 502 Bad Gateway
            if (httpResponse.status == 502) {
                throw new Error("Invalid response");
            }
            const jsonResponse = yield httpResponse.json();
            if (jsonResponse.id != id) {
                throw new Error("Invalid id in JsonRpcResponse");
            }
            if (jsonResponse.error || !httpResponse.ok) {
                throw new Error((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message);
            }
            return jsonResponse;
        });
    }
}
exports.JsonRpcClient = JsonRpcClient;
//# sourceMappingURL=client.js.map